import {settings} from "../config.ts";
import axios from "axios";

export async function getProfile(userId: string) {
    const config = {
        headers: {
            Authorization: `Bearer ${encodeURIComponent(userId)}`,
        },
    };
    try {
        const url = `${settings.url}users/profile`;

        const response = await axios.get(url, config)

        return response.data;
    } catch (e) {
        console.log("Ошибка", e)
    }
}

export async function withdrawGift(userId: string, giftId: number) {
    const config = {
        headers: {
            Authorization: `Bearer ${encodeURIComponent(userId)}`,
        },
        params: {
            id: giftId,
        }
    };

    try {
        const url = `${settings.url}users/profile/withdraw`

        const response = await axios.post(url,{id: giftId}, config)

        return response.data;
    } catch (e: any) {
        console.error("Ошибка при выводе подарка. Ответ сервера:", e.response?.data);
        throw e;
    }
}